// src/admin/milestones.js
// "My Story" timeline on the About page. Milestones are saved in about/main
// (public) as [{ year, text }] and edited under Site Content → About Text;
// suggestMilestones() drafts them from the resume so new education,
// roles and awards don't have to be typed twice.

const yearOf = (s = "") => (String(s).match(/\b(19|20)\d{2}\b/) || [""])[0];
const MONTHS = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
const monthOf = (s = "") => {
  const m = String(s).toLowerCase().match(/\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/);
  return m ? MONTHS.indexOf(m[1]) : -1;
};
const clean = (s) => String(s ?? "").replace(/\s+/g, " ").trim();

/** Chronological, without blanks; the order within a year is kept. */
export const normalizeMilestones = (list = []) =>
  (list || [])
    .map(m => ({ year: clean(m?.year), text: clean(m?.text) }))
    .filter(m => m.year && m.text)
    .map((m, i) => ({ ...m, i }))
    .sort((a, b) => Number(yearOf(a.year) || 0) - Number(yearOf(b.year) || 0) || a.i - b.i)
    .map(({ year, text }) => ({ year, text }));

/**
 * @param {object} resume      { education[], awards[] }
 * @param {Array}  experience  experience collection entries
 */
export const suggestMilestones = (resume = {}, experience = []) => {
  const out = [];
  const push = (date, text) => {
    const year = yearOf(date);
    if (year && clean(text)) out.push({ year, month: monthOf(date), text: clean(text) });
  };
  (resume.education || []).forEach(e => {
    push(e.startDate, `Started ${clean(e.degree) || "studies"}${e.institution ? ` at ${clean(e.institution)}` : ""}`);
    if (!e.current && e.grade) push(e.endDate, clean(e.grade));
  });
  (experience || []).filter(e => e && e.visible !== false).forEach(e => {
    push(e.startDate, `Joined ${clean(e.company)}${e.role ? ` as ${clean(e.role)}` : ""}`);
  });
  (resume.awards || []).forEach(a => push(a.date, a.title));

  const seen = new Set();
  return out
    .sort((a, b) => Number(a.year) - Number(b.year) || a.month - b.month)
    .filter(m => !seen.has(m.text.toLowerCase()) && seen.add(m.text.toLowerCase()))
    .map(({ year, text }) => ({ year, text }));
};
